export enum ECategoryType {
  ADMIN = 0, // 未指定 or ADMIN
  BREWERY = 1, // 酒蔵
  DISTRIBUTOR = 2, // ディストリビュータ
  RESTAURANT = 3, // レストラン
  CONSUMER = 4, // 消費者
}
